import { Accordion, Box, Text } from '@wix/design-system';
import React, { useState } from 'react';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import s from '../whoisResultsPage.scss';
const RawAccordion = _ref => {
  let title = _ref.title,
    text = _ref.text,
    buttonName = _ref.buttonName,
    whoisBiParams = _ref.whoisBiParams;
  const _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "D60",
    borderRadius: "12px",
    overflow: "hidden",
    className: s.rawDataAccordion
  }, /*#__PURE__*/React.createElement(Accordion, {
    items: [{
      title,
      toggleIconPlacement: 'start',
      open: isOpen,
      onToggle: () => {
        const next = !isOpen;
        setIsOpen(next);
        if (!whoisBiParams) {
          return;
        }
        DomainSearchGateModule.internals.bi.onWhoisGeneralAction == null || DomainSearchGateModule.internals.bi.onWhoisGeneralAction({
          ...whoisBiParams,
          action: next ? 'expand' : 'collapse',
          button_name: buttonName
        });
      },
      children: /*#__PURE__*/React.createElement(Box, {
        padding: "SP4 0"
      }, /*#__PURE__*/React.createElement(Text, {
        size: "small",
        secondary: true,
        className: s.rawDataText
      }, text))
    }]
  }));
};
export const RawDataSection = _ref2 => {
  let raw = _ref2.raw,
    whoisBiParams = _ref2.whoisBiParams;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  if (!raw.registry && !raw.registrar) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4"
  }, raw.registry && /*#__PURE__*/React.createElement(RawAccordion, {
    title: t('domain_search_gate.whois_results.accordion.raw_registry_data.title'),
    text: raw.registry,
    buttonName: "Raw Registry WHOIS Data",
    whoisBiParams: whoisBiParams
  }), raw.registrar && /*#__PURE__*/React.createElement(RawAccordion, {
    title: t('domain_search_gate.whois_results.accordion.raw_registrar_data.title'),
    text: raw.registrar,
    buttonName: "Raw Registrar WHOIS Data",
    whoisBiParams: whoisBiParams
  }));
};
//# sourceMappingURL=RawDataSection.js.map